document.addEventListener('DOMContentLoaded', () => {
  class HorizontalDragger {
    constructor(containerSelector) {
      this.container = document.querySelector(containerSelector);
      
      // Ensure the container exists before initializing
      if (!this.container) {
        return;
      }
      
      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.hasDragged = false;

      this.initEvents();
      this.updateScrollClasses(); // Initial update
    }

    initEvents() {
      this.container.addEventListener('mousedown', (e) => this.startDrag(e));
      this.container.addEventListener('mouseleave', () => this.stopDrag());
      this.container.addEventListener('mouseup', (e) => this.stopDrag(e));
      this.container.addEventListener('mousemove', (e) => this.drag(e));

      this.container.addEventListener('touchstart', (e) => this.startDrag(e));
      this.container.addEventListener('touchend', (e) => this.stopDrag(e));
      this.container.addEventListener('touchmove', (e) => this.drag(e), { passive: false }); // Disable passive mode

      // Monitor scroll to add/remove classes
      this.container.addEventListener('scroll', () => this.updateScrollClasses());
    }

    startDrag(event) {
      this.isDragging = true;
      this.hasDragged = false; // Reset drag status
      this.startX = event.type === 'mousedown' ? event.pageX : event.touches[0].pageX;
      this.scrollLeft = this.container.scrollLeft;

      // Add dragging class
      this.container.classList.add('js-dragging');

      // Prevent text selection or native touch scrolling
      event.preventDefault();
    }

    stopDrag(event) {
      if (!this.isDragging) return; // Prevent unnecessary executions

      this.isDragging = false;
      this.container.classList.remove('js-dragging');

      // Only allow click if the user hasn't dragged
      if (!this.hasDragged) {
        const link = event.target.closest('a');
        if (link) {
          link.click(); // Trigger the link click manually
        }
      }
    }

    drag(event) {
      if (!this.isDragging) return;

      const currentX = event.type === 'mousemove' ? event.pageX : event.touches[0].pageX;
      const deltaX = currentX - this.startX;

      // Detect if the user has dragged beyond a small threshold
      if (Math.abs(deltaX) > 5) {
        this.hasDragged = true; // Mark as dragged
      }

      // Perform the horizontal scroll
      this.container.scrollLeft = this.scrollLeft - deltaX;

      // Prevent default scrolling behavior during touchmove
      if (event.type === 'touchmove') {
        event.preventDefault();
      }
    }

    updateScrollClasses() {
      const scrollLeft = this.container.scrollLeft;
      const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;

      // Check if scrolled to the start
      if (scrollLeft <= 0) {
        this.container.classList.add('is-at-start');
      } else {
        this.container.classList.remove('is-at-start');
      }

      // Check if scrolled to the end
      if (scrollLeft >= maxScrollLeft) {
        this.container.classList.add('is-at-end');
      } else {
        this.container.classList.remove('is-at-end');
      }
    }
  }

  // Initialize the HorizontalDragger for the specified container
  new HorizontalDragger('.voyager-jump-link__items');
});
